export const FETCH_SERVEY_PENDING = 'FETCH_SERVEY_PENDING';
export const FETCH_SERVEY_SUCCESS = 'FETCH_SERVEY_SUCCESS';
export const FETCH_SERVEY_ERROR = 'FETCH_SERVEY_ERROR';

export const ON_ADD_NEW_QUESTION = 'ON_ADD_NEW_QUESTION';
export const ON_ADD_NEW_QUESTION_OPTION = 'ON_ADD_NEW_QUESTION_OPTION';
export const ON_CHANGE_QUESTION = 'ON_CHANGE_QUESTION';
export const ON_CHANGE_QUESTION_OPTION = 'ON_CHANGE_QUESTION_OPTION';